const ThunderIcon = ({
    width = 10,
    height = 18,
    fill = 'url(#paint0_linear_arrow_icon)',
    style = {},
    className = "",
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 10 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            className={className}
        >
            <path
                d="M0 16L3.38446 11.0694H0.509992L3.70898 6.42901H0.18548L4.96068 0H9L5.56346 4.01205L8.87498 3.91541L4.76159 9.136H8.02063L0 16Z"
                fill={fill}
            />
            <defs>
                <linearGradient
                    id="paint0_linear_arrow_icon"
                    x1="4.5"
                    y1="0"
                    x2="-0.358359"
                    y2="15.8904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#EEA415" />
                    <stop offset="1" stopColor="#FFD25E" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ThunderIcon;